import {
  METEOMATICS_SOURCES,
  METEOMATICS_PARAMETERS,
} from '@/utils/meteomatics/meteomaticsUtils.js';

export interface RadarTimestep {
  index: number;
  timestamp: number;
  isoString: string;
}

export type RadarStatus = 'idle' | 'loading' | 'precaching' | 'loaded' | 'error';

export interface RadarState {
  status: RadarStatus;
  activeIndex: number;
  totalCount: number;
  precacheProgress: number;
  errorMessage: string | null;
}

export interface RadarConfig {
  timestepCount: number;
  animationIntervalMs: number;
  tileSize: number;
  maxZoom: number;
  minZoom: number;
  opacity: number;
  layer: string;
  source: string;
  style: string;
  maxRequests: number;
  maxConcurrentPrefetch: number;
  debounceTime: number;
}

export const DEFAULT_RADAR_CONFIG: RadarConfig = {
  timestepCount: 12,
  animationIntervalMs: 700,
  tileSize: 512,
  maxZoom: 11,
  minZoom: 0,
  opacity: 0.5,
  layer: METEOMATICS_PARAMETERS.PRECIPITATION_1H,
  source: METEOMATICS_SOURCES.MIX,
  style: 'precip_segmented',
  maxRequests: 4,
  maxConcurrentPrefetch: 6,
  debounceTime: 300,
};
